import { render, staticRenderFns } from "./SubCostsCenters.vue?vue&type=template&id=5fa5aa6a&"
import script from "./SubCostsCenters.vue?vue&type=script&lang=js&"
export * from "./SubCostsCenters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports